import React from 'react'
import { useTranslation } from 'react-i18next'
import { Box, Text } from '@chakra-ui/core'

import { ProgressBar } from '@engyalo/storefront-components'

interface IMinAmountProgressProps {
  currencyPrefix: string
  currentAmount: number
  minAmount: number
}

export const MinAmountProgress = ({
  currencyPrefix,
  currentAmount,
  minAmount,
}: IMinAmountProgressProps): null | React.ReactElement => {
  const { t } = useTranslation()
  const remainingAmount = minAmount - currentAmount
  const currentProgress = (currentAmount / minAmount) * 100

  if (remainingAmount <= 0) {
    return null
  }

  return (
    <Box>
      <Text color="gray.100" textAlign="center" pb="2">
        {t('cart-minAmount', {
          remaining: `${currencyPrefix} ${remainingAmount.toFixed(2)}`,
          minimum: `${currencyPrefix} ${minAmount.toFixed(2)}`,
        })}
      </Text>
      <ProgressBar value={currentProgress} mb="4" />
    </Box>
  )
}
